import { render, staticRenderFns } from "./NoNavBar.vue?vue&type=template&id=2db1372c&"
import script from "./NoNavBar.vue?vue&type=script&lang=js&"
export * from "./NoNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports